import { DebtorSagas } from "./Debtor"
import { ChangeDebtorSagas } from "./ChangeDebtor"

export default [
    ...DebtorSagas,
    ...ChangeDebtorSagas
]